<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>

    <div class="form_box__main_box" v-loading="loading">
      <div class="form_box__group">
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">
            <RequireStar></RequireStar>权限名：
          </div>
          <div class="form_box__group__item__content">
            <el-input
              v-model="content"
              placeholder="请填写权限名"
              class="input_error"
              ref="input_content"
            ></el-input>
          </div>
        </div>
      </div>

      <div class="form_box__group">
        <div class="form_box__group__item">
          <div class="form_box__group__item__title">
            <RequireStar></RequireStar>添加许可：
          </div>
          <div class="form_box__group__item__content">
            <permissionbox @OnUpdate="OnUpdatePermission" ref="permissionBox"></permissionbox>
          </div>
        </div>
      </div>
    </div>

    <el-card class="form_box__group mt-2" v-loading="loading">
      <el-button style="margin-top: 12px;" type="primary" @click="save">更新</el-button>
    </el-card>
  </div>
</template>

<script>
import { initApi, updateApi } from "@/api/module/role/role.js";
import permissionbox from "@/views/components/role/permissionbox.vue";
import AppPageHeader from "@/views/components/role/AppPageHeader.vue";
import RequireStar from "@/views/components/role/RequireStar.vue";
export default {
  data() {
    return {
      content: "",
      pids: [],
      loading: false,
      cid: null,
    };
  },
  methods: {
    init() {
      var _this = this;
      _this.loading = true;

      _this.u = "";

      let data = {
        id: _this.id,
      };

      initApi(data)
        .then((result) => {
          _this.content = result.content;
          _this.cid = result.id;
          _this.$refs.permissionBox.doUpdate(result.id);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    // save
    save() {
      var _this = this;
      _this.loading = true;

      // 判断信息
      if (_this.content == null || _this.content.length == 0) {
        _this.$message.error("需要填写权限名");
        _this.$refs.input_content.focus();
        _this.loading = false;
        return;
      }

      let data = {
        id: _this.id,
        content: _this.content,
        pids: _this.pids,
      };

      updateApi(data)
        .then((result) => {
          // _this.$router.push("/role");
          _this.$message({
            message: "操作成功！",
            type: "success",
          });
          _this.init();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    OnUpdatePermission(item) {
      this.pids = item;
    },
  },
  beforeMount: function () {
    this.id = this.$route.query.id;
    this.init();
  },
  components: {
    AppPageHeader,
    RequireStar,
    permissionbox,
  },
};
</script>

<style>
</style>